/* eslint-disable react/no-danger */
import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import { loadPhotostoryLayoutData } from 'reduxUtils/modules_v2/layout';
import { setAdsConfig, processAdsCaimpaigns } from 'helpers/ads/utils';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
import Layout from 'components_v2/desktop/Layout';
import { loadPhotostoryData } from 'routes/photostory/redux';
import { getActiveCfmid } from 'reduxUtils/modules_v2/header';
import {
  setCacheTime,
  fireGA4Script,
  getIncrementalMaxAge,
} from 'utils/common';
import generatePhotostorySchema from 'helpers/seo/getPhotostorySchema';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import { ARTICLESHOW } from '../../../../constants';
import { createPhotostoryImageUrl } from '../../utils';
import PhotostoryWrapper from './PhotostoryWrapper';
import s from './Photostory.scss';

const pageName = 'photostory_desktop';

async function action(context, params) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const isBrowser = typeof window === 'object';
  const isServer = typeof window === 'undefined';
  const isWapView = false;
  let showMiniTv = true;
  let hideAdCude = false;
  let leadImageHref = '';
  const { pathname } = context;

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState();
  let isPrime = !!state.isPrime;

  const newParams = {
    ...params,
    fullPath: `/photostory/${params.msid}.cms`,
    isWapView,
    isAppView,
    skipSubSections: false,
    isClientConsumable: context.query.test === 'consumable',
    frmprime: state.isPrime ? 'yes' : '',
    photostoryMsid: params.msid,
  };

  let showPreload;
  const imageInfo = [];

  if (!state.photostory.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadPhotostoryData(newParams, isAppView)),
    );
  }

  if (
    !isAppView &&
    (!state.header.data || !state.footer_v2.data || !state.sidebar.data)
  ) {
    dataPromiseArray.push(
      context.store.dispatch(loadPhotostoryLayoutData(newParams)),
    );
  }
  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }
  state = context.store.getState();

  let status = 200;
  let redirect = false;
  let title = 'Get Latest News Updates from Times Of India';
  let dataAvailable =
    state.photostory &&
    state.photostory.data &&
    state.photostory.data[params.msid];

  const forcedErrorStatus =
    state.photostory && state.photostory.forcedErrorStatus
      ? state.photostory.forcedErrorStatus
      : null;

  const isPrimeIDs = ['91620576', '91618735', '66810254'];
  if (isPrimeIDs.indexOf(params?.msid) > -1) {
    status = 404;
    dataAvailable = false;
  }

  if (isServer && !dataAvailable) {
    status = 404;
  }
  if (forcedErrorStatus) {
    status = forcedErrorStatus;
    dataAvailable = false;
  }

  const htmltagsRegex = /(<([^>]+)>)/gi;

  if (dataAvailable) {
    const subsec1 = _get(state.photostory?.data[params.msid], 'subsec1', '');
    const isLifestyle = subsec1 && subsec1 === '2886704';
    const isVisualStory =
      state.photostory?.data[params.msid].metaInfo &&
      state.photostory?.data[params.msid].metaInfo.AMPStory &&
      state.photostory?.data[params.msid].metaInfo.AMPStory === '1';
    if (isVisualStory || isLifestyle) {
      status = 404;
      dataAvailable = false;
    }
  }

  if (dataAvailable) {
    title =
      state.photostory?.data[params.msid] &&
      state.photostory?.data[params.msid].seo
        ? state.photostory?.data[params.msid].seo.title
        : '';
    if (title) {
      title = title.replace(htmltagsRegex, '');
    }
    isPrime =
      state.photostory?.data[params.msid].cs &&
      state.photostory?.data[params.msid].cs.toLowerCase() === 'prime';
    if (
      state.photostory?.data[params.msid].filters &&
      state.photostory?.data[params.msid].filters.length > 0
    ) {
      context.store.dispatch(
        getActiveCfmid(state.photostory.data[params.msid].filters[0].cfmid),
      );
    }

    const photostoryData = state?.photostory?.data[params.msid];

    const firstPhotoData =
      photostoryData &&
      Array.isArray(photostoryData.items) &&
      photostoryData.items[0];

    if (firstPhotoData) {
      leadImageHref = createPhotostoryImageUrl(firstPhotoData, isWapView);
      if (leadImageHref) {
        imageInfo.push(leadImageHref);
      }
    }

    showPreload = imageInfo instanceof Array && imageInfo.length > 0;
  }

  // OverRidelink redirection
  if (!isBrowser && dataAvailable && state.photostory?.data[params.msid].seo) {
    const hOverRidelink =
      state?.photostory?.data[params.msid]?.seo?.hOverRidelink;
    if (hOverRidelink) {
      status = 301;
      redirect = hOverRidelink;
    }
    const photostoryData = state?.photostory?.data[params.msid];
    if (photostoryData.id && params.msid !== photostoryData.id) {
      const seoObj =
        state.seo && state.seo.data ? _get(state.seo, 'data', {}) : {};
      const canonicalURL = _get(
        photostoryData,
        `pwa_meta.canonical`,
        seoObj.canonical,
      );
      if (canonicalURL) {
        status = 301;
        redirect = canonicalURL;
      }
    }
  }

  const getComponent = async pageTitle => {
    let returnHtml;
    if (dataAvailable) {
      const prebidObj = _get(
        state,
        `common.siteConfig.prebid.templates.articleshow`,
      );

      const rhsWidgetPriorityPS = _get(
        state,
        `common.siteConfig.rhsWidgetPriorityPS`,
        {},
      );

      const rhsWidgetVideoAutoplay = _get(
        state,
        `common.siteConfig.rhsWidgetVideoAS.autoPlay`,
        '1',
      );
      context.store.dispatch(updatePrebidFlag(prebidObj));
      const categoryForGA = 'WEB-PHOTOSTORY';

      const isAdRemoved =
        state &&
        state.photostory &&
        state.photostory.data &&
        state.photostory.data[params.msid] &&
        state.photostory.data[params.msid]?.metaInfo &&
        state.photostory.data[params.msid]?.metaInfo?.SpecialID &&
        state.photostory.data[params.msid]?.metaInfo?.SpecialID === 'noad';
      if (isBrowser) {
        window.categoryForGA = categoryForGA;
        window.categoryForSearchGA = 'WEB-PHOTOSTORY';
        const secName = _get(
          state.photostory?.data[params.msid],
          'navsubsecs.subsec2.subsecname2',
          '',
        );
        setAdsConfig({ subSection: secName.toLowerCase() });
      }

      const photostoryData = state.photostory?.data[params.msid];
      /* code for SRA ads */
      if (_get(photostoryData, 'ads.dfp.experiment') === 'sra1') {
        newParams.delayTrackerAds = true;
        newParams.lazyloadRhsAds = true;
        newParams.lazyMobileBodyAds = true;
      }
      /* end code for SRA ads */

      const topSearches =
        state.commonData && state.commonData?.data?.topSearches;

      // const subSecSeoLocation =
      //   photostoryData.navsubsecs &&
      //   photostoryData.navsubsecs.subsec1 &&
      //   photostoryData.navsubsecs.subsec1.seolocation1;
      const jrevWidgets = _get(state, 'revenue.data.widgets', {});

      if (isAdRemoved || jrevWidgets?.skipAllWidget) {
        hideAdCude = true;
        showMiniTv = false;
      }

      const nextLinks = Array.isArray(photostoryData.nextItem)
        ? photostoryData.nextItem.slice(0, 4)
        : undefined;

      returnHtml = (
        <Layout
          layoutClass="layout_type_2"
          title={pageTitle}
          params={newParams}
          query={Object.keys(context.query).length ? context.query : {}}
          layoutType=""
          hideStickyBackToTop
          rhs={false}
          adPosition="masthead"
          showMiniTv={showMiniTv}
          showAdBlockerInINEU
          // hideAdBlockerDetector //comment this to add adblocker
          refreshFBNAd
          hideBreadcrumAtBottom
          hideAdCude={hideAdCude}
          pageType="ARTICLESHOW"
          isphotostory
          // subSecSeoLocation={subSecSeoLocation}
          gutterAdCode={_get(
            state,
            'revenue.data.ads.layout.gutter',
            undefined,
          )}
          showCovid19PopUp
          disablePopUpManager
          msid={newParams.msid}
          hideAffiliatesFloatingNudge
          enableCityChangeFeature
          templateName={ARTICLESHOW}
          overRideClass={s.miniTvtopband}
        >
          <PhotostoryWrapper
            parentPhotostoryData={photostoryData}
            seoData={state.seo && state.seo.data}
            photostoryMsid={params.msid}
            // photostories={state.photostory?.data}
            msid={params.msid}
            isAppView={isAppView}
            isWapView={isWapView}
            isUserPrime={!!state.isPrime}
            topSearches={topSearches}
            rhsWidgetPriorityPS={rhsWidgetPriorityPS}
            nextLinksData={nextLinks}
            rhsWidgetVideoAutoplay={rhsWidgetVideoAutoplay}
            isAdRemoved={isAdRemoved}
            widgets={state.common_widgets ? state.common_widgets.data : {}}
          />
        </Layout>
      );

      return returnHtml;
    }
    return (
      <div>
        Something went wrong. Click{' '}
        <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
      </div>
    );
  };

  const getMaxAge = () => {
    let maxAge = setCacheTime(state && state.isPrime);
    let modifiedTime = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.modified`,
      '',
    );
    if (!modifiedTime) {
      modifiedTime = _get(
        state,
        `photostory.data.${params.msid}.pwa_meta.publishtime`,
        '',
      );
    }
    const modifiedTimestamp = Math.floor(new Date(modifiedTime).getTime());
    if (!(state && state.isPrime) && modifiedTimestamp) {
      maxAge = getIncrementalMaxAge(modifiedTimestamp);
    }

    return maxAge;
  };

  const getSeoData = async () => {
    const seoObj =
      state.seo && state.seo.data ? _get(state.seo, 'data', {}) : {};

    seoObj.ogType = 'article';
    seoObj.article = true;
    seoObj.agencyName = _get(
      state,
      `photostory.data.${params.msid}.agency.name`,
      '',
    );

    seoObj.datePublished = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.dlseo`,
      seoObj.datePublished,
    );

    seoObj.dateModified = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.luseo`,
      seoObj.dateModified,
    );

    seoObj.title = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.title`,
      seoObj.title,
    );

    if (seoObj.title) {
      seoObj.title = seoObj.title.replace(htmltagsRegex, '');
    }

    seoObj.keywords = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.key`,
      '',
    );

    seoObj.news_keywords = seoObj.keywords;

    seoObj.amphtml = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.amphtml`,
      seoObj.amphtml,
    );

    seoObj.canonical = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.canonical`,
      seoObj.canonical,
    );

    seoObj.ogimage = _get(
      state,
      `photostory.data.${params.msid}.pwa_meta.ogimg`,
      seoObj.ogimage,
    );

    const photostoryData =
      state.photostory &&
      state.photostory.data &&
      params.msid &&
      state.photostory.data[params.msid];

    let schemaObj = [];
    if (photostoryData) {
      schemaObj = [generatePhotostorySchema(photostoryData, seoObj)];
    }

    if (schemaObj && schemaObj.length > 0) {
      seoObj.schema = schemaObj;
    }
    seoObj.noindexnofollow = '';
    seoObj.noindex = '';
    return seoObj;
  };

  //   const checkCoronaForSEO = data => {
  //     if (
  //       data &&
  //       data.title &&
  //       data.keywords &&
  //       (data.title.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
  //         data.title.toLocaleLowerCase().indexOf('covid') > -1 ||
  //         data.keywords.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
  //         data.keywords.toLocaleLowerCase().indexOf('covid') > -1)
  //     ) {
  //       return true;
  //     }
  //     return false;
  //   };
  // const isMultipublish = () => {
  //   if (
  //     state.photostory &&
  //     state.photostory.data &&
  //     state.photostory.data[params.msid] &&
  //     state.photostory.data[params.msid].multipublish
  //   ) {
  //     return true;
  //   }

  //   return false;
  // };

  //   const getGAConfig = async () => {
  //     let gaData = {};

  //     if (
  //       state.photostory &&
  //       state.photostory.data &&
  //       state.photostory.data[params.msid]
  //     ) {
  //       gaData = getGAData(state.photostory.data[params.msid]);
  //     }
  //     const sectionsNameList = getSectionsListFromBreadCrumb(
  //       state.navigation && state.navigation.breadCrumbs
  //         ? state.navigation.breadCrumbs
  //         : [],
  //     );
  //     gaData.dimension8 = getCustomDimension8(sectionsNameList);

  //     const isCovidRelated =
  //       state &&
  //       state.photostory &&
  //       state.photostory.data &&
  //       state.photostory.data[params.msid] &&
  //       state.photostory.data[params.msid].isCovid19Story;
  //     const coronaTextInSEOFeed =
  //       !isCovidRelated &&
  //       state &&
  //       state.photostory &&
  //       state.photostory.data &&
  //       state.photostory.data[params.msid] &&
  //       state.photostory.data[params.msid].seo &&
  //       checkCoronaForSEO(state.photostory.data[params.msid].seo);
  //     if (isCovidRelated || coronaTextInSEOFeed) {
  //       gaData.dimension23 = 'Covid-19';
  //     }
  //     const isAutoIngested =
  //       state &&
  //       state.photostory &&
  //       state.photostory.data &&
  //       state.photostory.data[params.msid] &&
  //       state.photostory.data[params.msid].metaInfo &&
  //       state.photostory.data[params.msid].metaInfo.AutoFeedIngestion;
  //     if (isAutoIngested === '1.0') {
  //       gaData.dimension27 = 'Auto Injested';
  //     }
  //     return gaData;
  //   };

  let adsTargetingObj = {};
  const layoutdata =
    state?.photostory?.data &&
    params?.msid &&
    state.photostory.data[params.msid];
  if (!isPrime && layoutdata) {
    const templateConfig = {
      Tmpl_SCN: 'Photostory',
      Channel: 'toi',
      isMobile: state.isMobile,
      pathname,
      articleId: params.msid,
      newkws: _get(layoutdata, 'newsKws', ''),
      kws: _get(layoutdata, 'seo.keywords', ''),
      specialId: _get(layoutdata, 'metaInfo.SpecialID'),
      navSubsecs: _get(layoutdata, 'navsubsecs', {}),
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      contentType: _get(layoutdata, 'metaInfo.Contenttype'),
    };
    const { keyValueObj, newCaimpaignConfig } = processAdsCaimpaigns(
      templateConfig,
    );
    const feedkeys = _get(layoutdata, 'adstargetkeyVals', {});
    adsTargetingObj = {
      ...feedkeys,
      ...keyValueObj,
    };
    if (typeof window === 'undefined' && status === 200) {
      // Revenue Active or not
      context.store.dispatch(updateCaimpaignAdsConfig(newCaimpaignConfig));
      // Page Ads call
      await context.store.dispatch(loadPageAdCode(templateConfig));
      state = context.store.getState();
    }
  }

  //   if (isBrowser) {
  //     setValue({
  //       isAppView,
  //       isWapView,
  //       artData:
  //         state &&
  //         state.photostory &&
  //         state.photostory.data &&
  //         state.photostory.data[params.msid],
  //       msid: params.msid,
  //     });
  //   }
  const gtmIDForOptimisely = ['GTM-54ZCD8R'];
  const dayssincecreated =
    state?.photostory?.data &&
    state?.photostory?.data[params.msid] &&
    state?.photostory?.data[params.msid]?.dl;
  if (typeof window !== 'undefined') {
    fireGA4Script({ vmsid: params.msid, params, dayssincecreated });
  }
  const afterAdsScript = [];

  const isAdRemoved =
    state &&
    state.photostory &&
    state.photostory.data &&
    state.photostory.data[params.msid] &&
    state.photostory.data[params.msid]?.metaInfo &&
    state.photostory.data[params.msid]?.metaInfo?.SpecialID &&
    state.photostory.data[params.msid]?.metaInfo?.SpecialID === 'noad';

  const noAdArticle = state.isPrime || isAdRemoved;
  let sSjConf = null;

  if (!noAdArticle) {
    const webInterstitial = {
      cookExpireInhours: 1,
      skipInitialCall: true,
    };
    sSjConf = { webInterstitial };
  }
  const revWidgets = _get(state, 'revenue.data.widgets', {});
  const isNewGam = _get(revWidgets, 'isNewGam', false);

  return {
    chunks: [pageName],
    title,
    seoData: await getSeoData(),
    maxAge: getMaxAge(),
    // gaData: await getGAConfig(),
    status,
    component: await getComponent(title),
    adsTargetingObj,
    preconnectDomains: ['//tpapi.timespoints.com'],
    // multipublish: isMultipublish(),
    multipublish: false,
    isMaxImagePreview: true,
    isMaxVideoPreview: false,
    shiftGutter: true,
    skipGpt: !isWapView,
    skipRouteAds: state.isPrime || isAdRemoved,
    removeThirdParty: isAdRemoved,
    addPersonaliseLib: false, //todo:
    skipPageViewGAOnLoad: true,
    gtmIDList: gtmIDForOptimisely,
    isPerfExperimented: true,
    useVariableFonts: true,
    isPrime: state.isPrime,
    // inlineFirstFoldCSS: true,
    showPreload,
    imageInfo,
    redirect,
    edgeCacheTag: params.msid,
    xFrameOptions: true,
    afterAdsScript,
    enableInterstitial: !!sSjConf,
    jarvisAdsConfig: sSjConf,
    isNewGam,
    preventUserActionOnNIElements: true,
  };
}

export default action;
